<div class="chart-container">
    <div class="controls-section">
        <select id="centerSelect" [(ngModel)]="centerType" (change)="updateCenterType()" class="custom-select">
            <option value="centroid">Centroid</option>
            <option value="query">Query Word</option>
        </select>
    </div>
    <div class="chart-section">
        <div #chartContainer>
        </div>
    </div>

</div>